import { Box, DialogActions, DialogContent } from '@material-ui/core';
import React, { FC } from 'react';
import css from './SellOrTradeInEducation.module.css';

import { Button, DialogWithCloseButton, Divider } from '..';
import SellOrTradeInEducation from './SellOrTradeInEducation';

interface SellOrTradeInEducationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SellOrTradeInEducationModal: FC<SellOrTradeInEducationModalProps> = (
  props: SellOrTradeInEducationModalProps
) => {
  const { isOpen, onClose } = props;

  return (
    <DialogWithCloseButton
      open={isOpen}
      allowFullScreen
      maxWidth="lg"
      scroll="paper"
      onClose={onClose}
    >
      <DialogContent className={css.modalContent}>
        <SellOrTradeInEducation />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Box width="250px" margin="16px auto">
          <Button onClick={onClose}>Got It</Button>
        </Box>
      </DialogActions>
    </DialogWithCloseButton>
  );
};

export default SellOrTradeInEducationModal;
